import { Drawer } from '@arco-design/web-react'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import SidebarNav, { type SidebarNavProps } from '@/components/Layout/SidebarNav'
import ConsoleIconButton from '@/components/Layout/ConsoleIconButton'

interface MobileNavDrawerProps {
  visible: boolean
  onClose: () => void
  brandName: string
  sidebarProps: Omit<SidebarNavProps, 'collapsed' | 'variant'>
}

export default function MobileNavDrawer({
  visible,
  onClose,
  brandName,
  sidebarProps,
}: MobileNavDrawerProps) {
  const { t } = useTranslation()

  return (
    <Drawer
      visible={visible}
      placement="left"
      width={280}
      title={null}
      footer={null}
      closable={false}
      onCancel={onClose}
      className="console-mobile-nav-drawer md:hidden"
      bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      <div className="flex flex-col h-full bg-[var(--console-sidebar-bg)]">
        <div className="console-drawer-header h-14 px-3 flex items-center justify-between border-b border-[var(--console-divider)] flex-shrink-0">
          <div className="flex items-center gap-2.5 min-w-0">
            <img src="/logo.svg" alt={brandName} className="w-6 h-6 flex-shrink-0" />
            <div className="min-w-0">
              <div className="text-[15px] font-bold text-[var(--console-text)] tracking-[-0.01em] leading-none truncate">
                {brandName}
              </div>
              <div className="text-[10px] text-[var(--console-text-muted)] mt-0.5 truncate">
                {t('layout.consoleTagline')}
              </div>
            </div>
          </div>
          <ConsoleIconButton aria-label={t('layout.closeNavigation')} onClick={onClose}>
            <X size={16} />
          </ConsoleIconButton>
        </div>
        <SidebarNav {...sidebarProps} collapsed={false} variant="drawer" />
      </div>
    </Drawer>
  )
}
